import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './oportunidadeForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './oportunidadeActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';
import consts from '../consts';

class OPORTUNIDADE extends Component {

	state = {
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {

        return (
			<>
				<div 
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						flexWrap: 'wrap',
						backgroundColor: '#0F2748',
						width: '100%',
						padding: 16,
						color: '#ffffff'
					}}>
					<p style={{ margin: 0, padding: 0 }}>{this.props.oportunidadeTitulo}</p>

					<TextoInput chave='oportunidadeTitulo' />
				</div>

				<Background
					backgroundPosition={'center'}
					gradientStart='#0F2748'
					gradientEnd='#19CCCC'>
					<Content>
						<Aguardando aguardando={this.props.aguardando} />

						{this.props.modoTela == 'cadastro' ? (
							<Form onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'visualizacao' ? (
							<Form visualizacao onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'exclusao' ? (
							<Form excluir onSubmit={this.props.excluir} />
						) : null}
						{this.props.modoTela == 'lista' ? this.lista() : null}
					</Content>
				</Background>
			</>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => this.props.sessao.administrador || !item.finalizado);

		return (
			<>
				{this.state.registroAberto ? (
					<Row alignCenter>
						<Grid cols='12 8 6 4'>
							<ContentCard style={{ backgroundColor: '#ffffff', padding: 22 }}>								
								<ContentCardBody>
									<Row alignCenter>
										<div 
											style={{
												height: 220,
											}}>
											<img 
												style={{
													width: '100%',
													maxHeight: 200,
													height: 'auto',
													padding: 2,
												}}
												src={this.state.registroAberto.fotos && this.state.registroAberto.fotos[0] ? `${consts.URL}/${this.state.registroAberto.fotos[0].arquivo}` : null}
												title={''}>
											</img>
										</div>
									</Row>
									<Row>
										<Grid cols='12 12 12 12'>
											<label style={{ fontSize: 22, textAlign: 'center', width: '100%' }}>{this.state.registroAberto.nome}</label>
											<br />

											<label style={{ fontSize: 18, marginTop: 16 }}>Descrição:</label>{console.log(this.state.registroAberto.descricao)}
											{(this.state.registroAberto.descricao || '').split('\n').map(descricao =>
												<p style={{ fontSize: 18, padding: 0, margin: 0 }} key={descricao}>{descricao}</p>
											)}
											
											{this.state.registroAberto.data_realizacao &&
											<>
												<label style={{ fontSize: 18, marginTop: 16 }}>Realização:</label>
												<p style={{ fontSize:18, padding: 0, margin: 0 }}>{this.state.registroAberto.data_realizacao}</p>
											</>}

											{(this.state.registroAberto.local_realizacao || this.state.registroAberto.link_remoto_realizacao) &&
											<>
												<label style={{ fontSize: 18, marginTop: 16 }}>Local:</label>
												{this.state.registroAberto.local_realizacao &&
												<p style={{ fontSize: 18, padding: 0, margin: 0 }}>{this.state.registroAberto.local_realizacao}</p>}
												{this.state.registroAberto.link_remoto_realizacao &&
												<p style={{ fontSize: 18, padding: 0, margin: 0 }}><a href={this.state.registroAberto.link_remoto_realizacao}>{this.state.registroAberto.link_remoto_realizacao}</a></p>}
											</>}

											{(this.state.registroAberto.link_inscricao || this.state.registroAberto.outra_inscricao) &&
											<>	
												<label style={{ fontSize: 18, marginTop: 16 }}>Inscrição:</label>
												{this.state.registroAberto.link_inscricao &&
												<p style={{ fontSize: 18, padding: 0, margin: 0 }}><a href={this.state.registroAberto.link_inscricao}>{this.state.registroAberto.link_inscricao}</a></p>}
												{this.state.registroAberto.outra_inscricao &&
												<p style={{ fontSize: 18, padding: 0, margin: 0 }}>{this.state.registroAberto.outra_inscricao}</p>}
											</>}

											{this.state.registroAberto.contato &&
											<>	
												<label style={{ fontSize: 18, marginTop: 16 }}>Contato:</label>
												<p style={{ fontSize: 18, padding: 0, margin: 0 }}>{this.state.registroAberto.contato}</p>
											</>}
										</Grid>
									</Row>

									<br />				
										
									<Row alignCenter>
										<Grid cols='12 12 12 12'>
											<Button
												text='Voltar'
												type={'primary'}
												icon={'fa fa-chevron-left'}
												event={() => {
													this.setState({
														...this.state,
														registroAberto: null
													});
												}} />
										</Grid>
									</Row>
								</ContentCardBody>
							</ContentCard>
						</Grid>
					</Row>
				) : (
					<Row alignCenter>
						{this.props.sessao.administrador &&
						<Grid cols='12 6 4 3'>
							<Button
								text='Adicionar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ finalizado: false });
								}} />
						</Grid>}

						<Grid cols='12 12 12 10'>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
									justifyContent: 'center'
								}}>
								{lista.map(item => (
									<div
										key={item}
										style={{ 
											backgroundColor: '#ffffff',
											display: 'flex',
											flexDirection: 'column',
											margin: 8,
											borderRadius: '5%',
											padding: 16,
											width: 330,
											alignItems: 'center'
										}}>
										
										<label style={{ padding: 16, margin: 0, fontSize: 22, textAlign: 'center', color: '#0F2748' }}>{item.nome}</label>

										{this.props.sessao.administrador &&
										<p>{item.finalizado ? 'Finalizado' : 'Aberto'}</p>}

										<div 
											style={{
												height: 220,
											}}>
											<img 
												style={{
													width: '100%',
													maxHeight: 200,
													height: 'auto',
													backgroundColor: '#0F2748',
													padding: 2,
												}}
												src={item.fotos && item.fotos[0] ? `${consts.URL}/${item.fotos[0].arquivo}` : null}
												title={''}>
											</img>
										</div>
										
										<Button
											text='Saiba Mais'
											type={'primary'}
											icon={'fa fa-plus'}
											event={() => {
												this.setState({
													...this.state, 
													registroAberto: {
														...item
													}
												})
											}} />
										
										{this.props.sessao.administrador &&
										<div style={{ margin: 4, width: '100%', textAlign: 'center'}}>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash'}
												visible={true}
												event={() => {
													this.props.setModoTela('exclusao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</div>}
									</div>
								))}
							</div>
						</Grid>
					</Row>
				)}
			</>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.oportunidade.modoTela,
	aguardando: state.oportunidade.aguardando,
	lista: state.oportunidade.lista,
	oportunidadeTitulo: state.texto.lista.filter(item => item.chave == 'oportunidadeTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OPORTUNIDADE);
